import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setAuth0Client } from "./api/authService";

export function AuthInitializer({ children }) {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    setAuth0Client({ getTokenSilently: getAccessTokenSilently });
  }, [getAccessTokenSilently]);

  return children;
}